import { defaultGrades } from 'src/data/datasource/mock/helpers/grades'
import { IProgram } from 'src/shared/interface/model.interface'

export const provideMockedPrograms = (): IProgram[] => {
  const programs: IProgram[] = []
  let index = 0

  defaultGrades.forEach(grade => {
    grade.programs.forEach(program => {
      programs.push({
        id: index,
        beltCode: grade.beltColor,
        comment: program.comment,
        gradeOrder: grade.gradeOrder,
        gradeLevel: grade.gradeLevel,
        isDan: grade.isDan,
        isKyu: grade.isKyu,
        label: program.label,
        programOrder: program.order,
        videos: []
      })
      index = index + 1
    })
  })
  return programs
}
